import * as React from 'react';
import {Modal} from '../../../../../shared/components/modal/modal';
import {useStyles} from '../../../../../shared/hooks/styles';
import {EmailConfirmation} from '../../emailConfirmation';

interface Props {
  onClose: () => void;
}

export const EmailConfirmationModal: React.FC<Props> = ({onClose}) => {
  const styles = useStyles(({theme}) => {
    return {
      wrapStyle: {
        paddingHorizontal: 65,
      },
      contentStyle: {
        paddingTop: 30,
      },
      titleStyle: {
        ...theme.fonts.h3,
        paddingTop: 0,
      },
    };
  });

  return (
    <Modal
      wrapStyle={styles.wrapStyle}
      contentStyle={styles.contentStyle}
      title='Подтвердите новую эл. почту'
      titleStyle={styles.titleStyle}
      onClose={onClose}>
      <EmailConfirmation />
    </Modal>
  );
};
